import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('America/Chicago');

export function convertToCentralSameTime (value: string): dayjs.Dayjs {
    if(!value || value.length === 0)
        return new dayjs.Dayjs
    return dayjs.tz(value)
}

export function getCentralCurrentTime (): dayjs.Dayjs {
    return dayjs.tz()
}
